<div class="container">
  <a
    class="container__item"
    target="_blank"
    href="https://book.froebel-kan.co.jp/ "
  >
    フレーベル館出版サイト
  </a>
  <a
    class="container__item"
    target="_blank"
    href="https://www.yokohama-anpanman.jp/buy/shop/kmwr34dkduwjmxfi.html "
  >
    もりのほんやさん
  </a>
  <a
    class="container__item"
    target="_blank"
    href="https://ec.froebel-kan.co.jp/shop/c/cpersonal/?_gl=1*is55a0*_ga*MTQyNTI1NjIwNC4xNzQyNTE4NjM3*_ga_WB8GP6WBYF*czE3NTIwMjM3MzkkbzIwJGcwJHQxNzUyMDIzNzM5JGo2MCRsMCRoMA"
  >
    フレーベル館公式オンラインショップ
  </a>
  <a
    class="container__item"
    target="_blank"
    href="https://asoppa.com/ "
  >
    子どものあそび情報サイト　ASOPPA！
  </a>
</div>
